import { Kbd, Text } from "@mantine/core";

import { Button } from "../../../shared/Button/Button";
import { StyledCrewTransferHint } from "./styled/crewTransferMenu.styled";

interface Props {
  showClearButton: boolean;
  onClearSelections: () => void;
}

const CrewTransferMenuHint = ({
  showClearButton,
  onClearSelections,
}: Props) => (
  <StyledCrewTransferHint>
    <Text size="xs">
      <span style={{ fontWeight: 200 }}>Hint: </span> Use
      <Kbd>Shift</Kbd> + <Kbd>Mouse click</Kbd> to select multiple crew members
    </Text>
    {showClearButton && (
      <Button size="xs" onClick={onClearSelections} className="fadeIn">
        <Text weight={200}>Clear selections</Text>
      </Button>
    )}
  </StyledCrewTransferHint>
);
export default CrewTransferMenuHint;
